import React, { useEffect, useRef, useState } from 'react'
import { Line } from 'react-chartjs-2'
import {
  Chart,
  TimeScale,
  LinearScale,
  PointElement,
  LineElement,
} from 'chart.js'
import 'chartjs-adapter-date-fns'
import axios from 'axios'
import zoomPlugin from 'chartjs-plugin-zoom'

// رجیستر کردن مقیاس و عناصر مورد نیاز
Chart.register(TimeScale, LinearScale, PointElement, LineElement, zoomPlugin)

const ChartPage = ({ title, chartType, startDate, endDate, reloadCharts, handleReloadCharts, handleStartDate, handleEndDate, handleTableData }) => {
  const [chartData, setChartData] = useState(null)
  const [loading, setLoading] = useState(true)
  const chartRef = useRef(null);
  const resetZoomRef = useRef(null);
  // const [chartScales, setChartScales] = useState({});
  // const [originalLabels, setOriginalLabels] = useState([]);
  // const [oldDates, setOldDates] = useState([]);

  // دریافت اطلاعات نمئدار ها

  // const startDateRef = useRef(startDate);
  // const endDateRef = useRef(endDate);

  // useEffect(() => {
  //   endDate = endDate;
  // }, [endDate]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(
          process.env.REACT_APP_API_URL + '/api/last-send-data-device',
          {
            serial_number: process.env.REACT_APP_DEVICE_ID,
            name: 'TempE',
            from: startDate.getFullYear() + '-' + String(startDate.getMonth() + 1).padStart(2, '0') + '-' + String(startDate.getDate()).padStart(2, '0'), // استفاده از تاریخ شروع
            to: endDate.getFullYear() + '-' + String(endDate.getMonth() + 1).padStart(2, '0') + '-' + String(endDate.getDate()).padStart(2, '0'), // استفاده از تاریخ پایان
          }
        )

        handleTableData(response.data.data.table_date);

        if (chartType === 'batteryPower') {
          const batteryPowers = response.data.data.battery_powers
          // let labels = batteryPowers.map((item) => item.date)
          // const data = batteryPowers.map((item) => parseFloat(item.value))

          // setOriginalLabels([...labels]);

          // let newLabels = labels;

          // if (startDate.toLocaleDateString() !== endDate.toLocaleDateString()) {
          // newLabels = resetLabels(labels);
          // }

          // if (chartRef.current) {
          //   setChartScales({
          //     x: {
          //       ticks: {
          //         autoSkip: true,
          //         maxTicksLimit: 24,
          //       },
          //       min: chartRef.current.scales['x'].min,
          //       max: chartRef.current.scales['x'].max,
          //     },
          //   });
          // }

          let data_1 = batteryPowers.map((item) => {
            return {
              x: item.date.replace(' ', 'T'),
              y: parseFloat(item.value),
            };
          })

          setChartData({
            // labels: newLabels,
            datasets: [
              {
                label: 'Battery Power',
                data: data_1,
                borderColor: 'rgba(0,0,0,1)',
                backgroundColor: 'rgba(0,0,0,0.2)',
                pointBackgroundColor: 'rgba(0,0,0,1)',
                pointBorderColor: '#fff',
              },
            ],
          });
        } else if (chartType === 'loadVoltages') {
          const loadVoltagesOne = response.data.data.load_voltages_one
          const loadVoltagesTwo = response.data.data.load_voltages_two

          // const labelsVO1 = loadVoltagesOne.map((item) => item.date)
          // const vo1Data = loadVoltagesOne.map((item) => parseFloat(item.value))

          // const labelsVO2 = loadVoltagesTwo.map((item) => item.date)
          // const vo2Data = loadVoltagesTwo.map((item) => parseFloat(item.value))

          // setOriginalLabels([...labelsVO1, ...labelsVO2]);

          // let newLabelsVO1 = labelsVO1,
          //   newLabelsVO2 = labelsVO2;

          // if (startDate.toLocaleDateString() !== endDate.toLocaleDateString()) {
          // newLabelsVO1 = resetLabels(labelsVO1);
          // newLabelsVO2 = resetLabels(labelsVO2);
          // }
          // console.log(newLabelsVO1);
          // console.log(vo1Data);
          // console.log(vo2Data);
          // console.log(chartRef.current.scales['x'].min);
          // if (chartRef.current) {
          // let ticks = {};

          // if (startDate.toLocaleDateString() === endDate.toLocaleDateString()) {
          //   ticks = {
          //     autoSkip: true,
          //     maxTicksLimit: 24,
          //   };
          // }

          // setChartScales({
          //   x: {
          //     // ticks: ticks,
          //     min: chartRef.current.scales['x'].min,
          //     max: chartRef.current.scales['x'].max,
          //   },
          // });
          // }

          let data_1 = loadVoltagesOne.map((item) => {
            return {
              x: item.date,
              y: parseFloat(item.value),
            };
          })

          let data_2 = loadVoltagesTwo.map((item) => {
            return {
              x: item.date,
              y: parseFloat(item.value),
            }
          })

          setChartData({
            // labels: newLabelsVO1,
            datasets: [
              {
                label: 'VO1',
                // data: vo1Data,
                data: data_1,
                borderColor: 'rgba(54,162,235,1)',
                backgroundColor: 'rgba(54,162,235,0.2)',
                pointBackgroundColor: 'rgba(54,162,235,1)',
                pointBorderColor: '#fff',
              },
              {
                label: 'VO2',
                // data: vo2Data,
                data: data_2,
                borderColor: 'rgba(255,99,132,1)',
                backgroundColor: 'rgba(255,99,132,0.2)',
                pointBackgroundColor: 'rgba(255,99,132,1)',
                pointBorderColor: '#fff',
              },
            ],
          })
        } else if (chartType === 'batteryVoltage') {
          const batteryVoltages = response.data.data.battery_voltages
          let labels = batteryVoltages.map((item) => item.date)
          const data = batteryVoltages.map((item) => parseFloat(item.value))

          // setOriginalLabels([...labels]);

          let newLabels = labels;

          // if (startDate.toLocaleDateString() !== endDate.toLocaleDateString()) {
          // newLabels = resetLabels(labels);
          // }

          // if (chartRef.current) {
          //   setChartScales({
          //     x: {
          //       ticks: {
          //         autoSkip: true,
          //         maxTicksLimit: 24,
          //       },
          //       min: chartRef.current.scales['x'].min,
          //       max: chartRef.current.scales['x'].max,
          //     },
          //   });
          // }

          setChartData({
            labels: newLabels,
            datasets: [
              {
                label: 'Battery Voltage',
                data,
                borderColor: 'rgba(0,123,255,1)',
                backgroundColor: 'rgba(0,123,255,0.2)',
                pointBackgroundColor: 'rgba(0,123,255,1)',
                pointBorderColor: '#fff',
              },
            ],
          })
        } else if (chartType === 'statusChart') {
          const statusGens = response.data.data.statusGens
          const statusSsrs = response.data.data.statusSsrs

          let labels = [
            ...new Set([
              ...statusGens.map((item) => item.date),
              ...statusSsrs.map((item) => item.date),
            ]),
          ].sort()

          // setOriginalLabels([...labels]);

          let newLabels = labels;

          // if (startDate.toLocaleDateString() !== endDate.toLocaleDateString()) {
          // newLabels = resetLabels(labels);
          // }

          // if (chartRef.current) {
          //   setChartScales({
          //     x: {
          //       ticks: {
          //         autoSkip: true,
          //         maxTicksLimit: 24,
          //       },
          //       min: chartRef.current.scales['x'].min,
          //       max: chartRef.current.scales['x'].max,
          //     },
          //   });
          // }

          // const gensData = statusGens.map((item) => parseFloat(item.value))
          // const ssrsData = statusSsrs.map((item) => parseFloat(item.value))

          const gensMap = Object.fromEntries(statusGens.map((item) => [item.date, parseFloat(item.value)]));
          const ssrsMap = Object.fromEntries(statusSsrs.map((item) => [item.date, parseFloat(item.value)]));

          // const gensData = labels.map((date) => gensMap[date] || 0);
          // const ssrsData = labels.map((date) => ssrsMap[date] || 0);

          const interpolateData = (labels, dataMap) => {
            let data = labels.map((date, index) => {
              if (dataMap[date] !== undefined) {
                return dataMap[date];
              }

              let prevIndex = index - 1;
              let nextIndex = index + 1;

              while (prevIndex >= 0 && dataMap[labels[prevIndex]] === undefined) {
                prevIndex--;
              }
              while (nextIndex < labels.length && dataMap[labels[nextIndex]] === undefined) {
                nextIndex++;
              }

              if (prevIndex >= 0 && nextIndex < labels.length) {
                let prevValue = dataMap[labels[prevIndex]];
                let nextValue = dataMap[labels[nextIndex]];
                let prevDate = new Date(labels[prevIndex]).getTime();
                let nextDate = new Date(labels[nextIndex]).getTime();
                let currDate = new Date(date).getTime();

                return Math.round(prevValue + ((nextValue - prevValue) * (currDate - prevDate)) / (nextDate - prevDate));
              }

              return Math.round(prevIndex >= 0 ? dataMap[labels[prevIndex]] : dataMap[labels[nextIndex]]);
            });

            return data;
          };

          // Generate interpolated datasets
          const gensData = interpolateData(labels, gensMap);
          const ssrsData = interpolateData(labels, ssrsMap);

          setChartData({
            labels: newLabels,
            datasets: [
              {
                label: 'GENS',
                data: gensData,
                borderColor: 'rgba(75,192,192,1)',
                backgroundColor: 'rgba(75,192,192,0.2)',
                pointBackgroundColor: 'rgba(75,192,192,1)',
                pointBorderColor: '#fff',
              },
              {
                label: 'SSRS',
                data: ssrsData,
                borderColor: 'rgba(255,159,64,1)',
                backgroundColor: 'rgba(255,159,64,0.2)',
                pointBackgroundColor: 'rgba(255,159,64,1)',
                pointBorderColor: '#fff',
              },
            ],
          })
        }

        setLoading(false)
      } catch (error) {
        console.error('Error fetching data:', error)
        setLoading(false)
      }

      handleReloadCharts(false)
    }

    if (reloadCharts) {
      fetchData()
    }

    const interval = setInterval(fetchData, 60000) // هر 60 ثانیه یکبار

    return () => clearInterval(interval) // پاک‌سازی بازه زمانی هنگام خروج از کامپوننت
  }, [chartType, reloadCharts, handleReloadCharts, handleTableData])

  const handleResetZoom = () => {
    if (chartRef.current) {
      chartRef.current.resetZoom();

      // handleStartDate(oldDates[0]);
      // handleEndDate(oldDates[1]);

      // handleReloadCharts(true);
    }

    resetZoomRef.current.style.display = 'none';
  };

  // const resetLabels = (labels) => {
  //   let lastDate = null;

  //   labels.forEach((label, index) => {
  //     let [date, time] = label.split(' ');

  //     if (date !== lastDate) {
  //       lastDate = date;
  //       labels[index] = new Date(label).toLocaleDateString('en-US', {
  //         day: 'numeric',
  //         month: 'short',
  //       });
  //     } else {
  //       labels[index] = time.substring(0, 5);
  //     }
  //   });

  //   return labels;
  // };

  // تنظیمات کلی نمودار
  const chartOptions = {
    responsive: true,
    plugins: {
      legend: { position: 'top' },
      // tooltip: {
      //   enabled: true,
      // },

      tooltip: {
        callbacks: {
          title: function (tooltipItems) {
            return new Date(tooltipItems[0].parsed.x).toLocaleString();
          }
        }
      },

      zoom: {
        pan: {
          enabled: true,
          mode: 'x',
          modifierKey: 'ctrl',
        },
        zoom: {
          drag: {
            enabled: true
          },
          mode: 'x',
          onZoomStart: ({ chart }) => {
            // const xScale = chart.scales.x;
            // const start = xScale.min;
            // const end = xScale.max;

            // setOldDates([new Date(originalLabels[start]), new Date(originalLabels[end])]);
          },
          onZoomComplete: ({ chart }) => {
            // const xScale = chart.scales.x;
            // const start = xScale.min;
            // const end = xScale.max;

            //   handleStartDate(new Date(originalLabels[start]));
            //   handleEndDate(new Date(originalLabels[end]));

            //   handleReloadCharts(true);

            resetZoomRef.current.style.display = 'block';
          },
        },
      },
    },
    // scales: {
    //   x: chartScales.x || {},
    //   /*
    //   x: {
    //     type: 'time',
    //     time: {
    //       unit: 'hour',
    //       displayFormats: { hour: 'HH:mm' },
    //       stepSize: 3,
    //     },
    //     title: { display: true, text: 'Time' },
    //     min: startDate.setHours(0, 0, 0, 0),
    //     max: endDate.setHours(23, 59, 59, 999),
    //   },
    //   */
    //   y: {
    //     title: {
    //       display: true,
    //       text:
    //         chartType === 'statusChart'
    //           ? 'Status Values (0, 1, 2)'
    //           : chartType === 'batteryVoltage'
    //             ? 'Voltage (V)'
    //             : chartType === 'batteryPower'
    //               ? 'Power (W)'
    //               : 'Load Voltage (V)',
    //     },
    //     ticks: {
    //       ...(chartType === 'statusChart' && {
    //         stepSize: 1,
    //         callback: (value) => ([0, 1, 2].includes(value) ? value : null),
    //       }),
    //     },
    //     ...(chartType === 'statusChart' && {
    //       min: 0,
    //       max: 2,
    //     }),
    //     beginAtZero: true,
    //   },
    // },

    scales: {
      x: {
        type: 'time',
        time: {
          unit: 'hour',
          displayFormats: {
            day: 'MMM dd',
            hour: 'HH:mm',
          },
          tooltipFormat: 'MMM dd, HH:mm'
        },
        ticks: {
          maxTicksLimit: 6,
          // autoSkip: false,
          // source: 'data',
          // stepSize: 1,
          maxRotation: 45, // Maximum rotation angle
          minRotation: 45,  // Minimum rotation angle (force 90 degrees)
          callback: function (value, index, ticks) {
            const diff = ticks[ticks.length - 1].value - ticks[0].value;
            const currentDate = new Date(ticks[index].value);
            const previousDate = index > 0 ? new Date(ticks[index - 1].value) : null;

            if (!previousDate || currentDate.getDate() !== previousDate.getDate()) {
              return currentDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
            } else {
              // let currentDateTicks = ticks.filter((tick) => new Date(tick.value).getDate() === currentDate.getDate());
              // const ticksPerDay = ticks.filter((tick) => new Date(tick.value).getDate() === currentDate.getDate()).length;
              // const currentIndex = ticks.indexOf(ticks.find((tick) => new Date(tick.value).getDate() === currentDate.getDate()));         
              // const currentDayIndex = ticks.findIndex((tick) => new Date(tick.value).getDate() === currentDate.getDate());
              // console.log(currentDateTicks);

              const currentDateTicks = ticks.filter((tick) => new Date(tick.value).getDate() === currentDate.getDate());
              const currentIndex = currentDateTicks.findIndex((tick) => tick.value === ticks[index].value);

              // || Math.round(currentDateTicks.length / 2) !== currentIndex
              // currentDate.getDay() == previousDate.getDay() && currentDate.getHours() != previousDate.getHours()
              if (diff <= 24 * 60 * 60 * 1000) {
                // nothing
              } else if (diff <= 7 * 24 * 60 * 60 * 1000 && Math.round(currentDateTicks.length / 2) === currentIndex) {
                // nothing
              } else {
                return null;
              }

              return currentDate.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
            }
          }
        }
      },
      y: {
        beginAtZero: true
      }
    },
  }


  if (loading) return <p>Loading...</p>

  return (
    <div>
      <div>
        <h2 className='chart-title'>{title}</h2>
        <button ref={resetZoomRef} onClick={handleResetZoom} className='reset-zoom-button' style={{ display: 'none', float: 'right' }}>
          Reset Zoom
        </button>
      </div>
      <Line ref={chartRef} data={chartData} options={chartOptions} />
    </div>
  )
}

export default ChartPage
